import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'sectionSelect', 'section'];

  connect() {
    this.toggle();
  }

  toggle() {
    this.limitParents();

    // A sub-hub is a Section with a parent, so it shows every Section field.
    const choices = [this.selectTarget.value, this.pageClass(), this.sectionPageType()];

    this.sectionTargets.forEach((section) => {
      const owners = (section.dataset.pageTypes ?? '').split(' ');
      const visible = choices.some((choice) => choice && owners.includes(choice));

      // The `hidden` attribute loses to the card component's own `display`, so
      // the utility class does the hiding.
      section.classList.toggle('hidden', !visible);
      section.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = !visible;
      });
    });
  }

  pageClass() {
    return this.selectTarget.value === 'sub_hub' ? 'ContentPage::Section' : '';
  }

  sectionPageType() {
    if (this.selectTarget.value !== 'page' || !this.hasSectionSelectTarget) return '';

    return this.sectionSelectTarget.selectedOptions[0]?.dataset.pageType ?? '';
  }

  // A sub-hub can only sit under one of the site's hubs, so it is not
  // offered the other sub-hubs as a parent.
  limitParents() {
    if (!this.hasSectionSelectTarget) return;

    const hub = this.selectTarget.value === 'sub_hub';

    Array.from(this.sectionSelectTarget.options).forEach((option) => {
      if (!('subHub' in option.dataset)) return;

      // Safari ignores `hidden` on an option, so it is disabled as well.
      option.hidden = hub;
      option.disabled = hub;
      if (hub && option.selected) this.sectionSelectTarget.value = '';
    });
  }
}
